import { useTranslation } from 'react-i18next';

import { Alert } from '@myphx-engineering/phx-design-system';

export interface KratosPasswordErrorProps {
    errorMessage?: string;
}

export const KratosPasswordError = ({
    errorMessage,
}: KratosPasswordErrorProps) => {
    const { t } = useTranslation();
    return (
        <Alert data-testid="kratos-password-error" severity="error">
            {errorMessage || t('formErrors.kratosPasswordError.defaultMessage')}
        </Alert>
    );
};
